import { EhrData } from 'chaika-frontend-types/frontend-cms';

import { Ehr } from '@patient/store/ehr/Ehr';

import { PatientListModel } from '@store/models/Patient/PatientListModel';

export class PatientList extends PatientListModel<Ehr, EhrData> {
    protected modelClass = Ehr;
}
